import cx from 'classnames';

import SectionHeader from './sectionHeader';
import Review from './review';
import { makeid, reviews } from '../../constants';

import styles from '../../styles/plan/customerReviews.scss';

const CustomerReveiws = () => (
  <div className={cx('mb30 reviews-block')}>
    <SectionHeader title="Customer Reviews" golden />
    <ul className={styles.list}>
      {(reviews || []).slice(0, 3).map((review: any) => (
        <li
          key={review.review}
          className={cx('large-4 medium-4 small-12 columns', styles.review)}
        >
          <Review key={makeid()} data={review} />
        </li>
      ))}
    </ul>
  </div>
);

export default CustomerReveiws;



// WEBPACK FOOTER //
// ./components/plan/customerReveiws.tsx